import axios from 'axios';
import { config } from '../config';  // URL base para a API

// Função para logar eventos de auditoria
export const logAction = async (action, userContext, details = {}) => {
    const logData = {
        action,               // Ação realizada (ex: "login", "edição de cadastro", etc)
        timestamp: new Date(), // Data e hora
        user: {
            nome: userContext.nomeUsuario,
            email: userContext.emailUsuario,
            condominio: userContext.codigoCondominio
        },
        details               // Detalhes adicionais da ação (ex: ID do cadastro alterado)
    };

    try {
        await axios.post(`${config.apiBaseUrl}/logs/auditoria`, logData);
        console.log("Log enviado com sucesso");
    } catch (error) {
        console.error("Erro ao enviar log:", error);
    }
};
